exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".msgManage{min-height:calc(100vh - 60px)}.msgManage .el-select{display:inline-block}.msgManage .el-input{display:inline-block;width:auto}.msgManage .el-button{display:inline-block}.msgManage .el-button+.el-button{margin-left:0}.search{margin-left:30px}.dynamics{margin-top:20px}.time_msg{display:inline-block}.item_msg{border:1px solid #e3e3e3;margin-bottom:20px;padding:20px;box-sizing:border-box;position:relative}.headImg_msg{display:inline-block;width:80px;height:80px;border-radius:50%}.name_msg{vertical-align:top;margin-bottom:20px}.text_msg_box{width:70%;height:100%}.text_msg_box,span.time_msg{display:inline-block;margin-left:15px;vertical-align:top}.noData{color:#5e6d82;text-align:center;margin-top:20px;height:50px;line-height:50px;border:1px solid #e3e3e3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7c7216f4!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/secretary/message/msgManage.vue
// module id = 589
// module chunks = 0